import React from 'react';
import './juniper-scheduled-pill.scss';

// Inverse of CalcomEventPill: marks an event scheduled with Juniper's built-in scheduling rather
// than Cal.com. Shown on non-Cal.com events so the scheduling source is explicit — walkthroughs
// (and key pickups) can be booked either way, so "no Cal.com pill" shouldn't be the only signal.
const JuniperScheduledPill = () => (
  <span className="juniper-scheduled-pill">
    <span className="juniper-scheduled-pill-dot" />
    Scheduled in Juniper
  </span>
);

export default JuniperScheduledPill;